// @flow

import * as React from 'react';

import { Svg, type SvgProps } from '@gandi/ui';

import styles from './Icon.scss';

type Props = {
  name: SvgProps['name'],
  theme: SvgProps['theme'],
  title: SvgProps['title'],
};

export default function Icon({
  name,
  theme,
  title,
}: Props): React.MixedElement {
  return (
    <Svg name={name} theme={theme} title={title} className={styles.icon} />
  );
}
